import { render } from "./InsiteIndexTable.vue?vue&type=template&id=532b28ef"
import script from "./InsiteIndexTable.vue?vue&type=script&lang=js"
export * from "./InsiteIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__